const ai = {
  header: {
    title: "Модуль ИИ-обработки",
    description: "Настройте языковую модель для перефразирования, перевода и извлечения хэштегов из публикаций.",
  },
  providers: {
    label: "Выберите ИИ-провайдера",
    geminiDescription: "Быстрый и мощный набор моделей Google AI.",
    openrouterDescription: "Доступ к открытым и коммерческим языковым моделям через единую точку доступа.",
    personalCredential: "Ваш API-ключ",
    enabled: "Личный ключ настроен",
    missingSecret: "Добавьте API-ключ",
    select: "Выбрать {{provider}}",
  },
  credentials: {
    title: "Личный API-ключ",
    description: "Этот ключ {{provider}} принадлежит только вашей учетной записи и используется только для ваших ИИ-запросов.",
    label: "API-ключ {{provider}}",
    placeholder: "Вставьте ваш API-ключ {{provider}}",
    configured: "Настроен",
    maskedNote: "Сохраненный ключ скрыт и никогда не отображается обратно в браузере.",
    save: "Сохранить личный ключ",
    saving: "Сохранение…",
    saved: "Ключ {{provider}} безопасно сохранен.",
    replace: "Заменить ключ",
    remove: "Удалить ключ",
    removing: "Удаление…",
    removeConfirm: "Удалить сохраненный API-ключ {{provider}}? Запросы ИИ через этого провайдера остановятся, пока вы не добавите новый ключ.",
    removeError: "Не удалось удалить ваш API-ключ.",
    cancel: "Отмена",
    test: "Проверить ключ",
    testing: "Проверка…",
    testSuccess: "Подключение успешно. Ключ пока не сохранен.",
    testError: "Не удалось проверить API-ключ.",
    security: "Ключ отправляется только на сервер, хранится в Supabase Vault и никогда не возвращается в браузер.",
    saveError: "Не удалось сохранить ваш API-ключ.",
  },
  models: {
    label: "Выберите модель ИИ",
    custom: "Своя модель…",
    customInputLabel: "Идентификатор пользовательской модели",
    customPlaceholder: "например, meta-llama/llama-3.1-405b-instruct",
    apply: "Применить",
    current: "Текущая активная модель ИИ:",
    select: "Выбрать модель {{model}}",
  },
  playground: {
    title: "Тестовая площадка ИИ",
    description: "Проверьте активного ИИ-провайдера и выбранную модель. Текст отправляется через обычный серверный endpoint обработки с творческим вирусным контекстом перефразирования.",
    credentialRequired: "Добавьте личный API-ключ {{provider}}, прежде чем запускать тест.",
    inputLabel: "Тестовый текст",
    placeholder: "Вставьте текст для проверки…",
    sample: "Сбор публикаций из Telegram-каналов помогает готовить отраслевые новостные дайджесты.",
    output: "Результат обработки",
    error: "Ошибка обработки",
    testing: "Проверка подключения к ИИ…",
    run: "Запустить тест ИИ",
  },
  errors: {
    generationFallback: "ИИ не смог сформировать тестовый ответ.",
    connectionFallback: "Не удалось подключиться. Проверьте API-ключ и настройки провайдера.",
  },
} as const;

export default ai;
